import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export type BlotterOpenInXoneQueryPayload = {
  reference: string;
};

export const openInXone = (builder: WebapiEndpointBuilder) => {
  return builder.query<void, BlotterOpenInXoneQueryPayload>({
    keepUnusedDataFor: 0,
    query: (body) => ({
      url: '/desktopAutomation/openReference',
      method: 'POST',
      body,
    }),
  });
};
